import type { EmailSearchInput } from "hooks/useEmailsRestApi";
import type { FC, RefObject } from "react";
import type { EmailWithStatus } from "routes/emails/SearchEmailsPage";
import { HREmailsCardsUI } from "routes/emails/SearchEmailsPage/components/HREmailsCards";
import { MatterEmailsCardsUI } from "routes/emails/SearchEmailsPage/components/MatterEmailsCards";

export type EmailsCardsUIProps = {
  isMatter: boolean;
  emails: EmailWithStatus[];
  onSelectEmail: (id: string) => void;
  onOpenDetail?: (id: string) => void;
  onToggleFavoriteEmail: (emailId: string, favorite: boolean) => void;
  currentSearchInput: EmailSearchInput;
  scrollCardRef: RefObject<HTMLDivElement>;
  scrollCardId: string | null;
  selectedId?: string | null;
};

export const EmailsCardsUI: FC<EmailsCardsUIProps> = ({
  isMatter,
  emails,
  onSelectEmail,
  onOpenDetail,
  onToggleFavoriteEmail,
  currentSearchInput,
  scrollCardRef,
  scrollCardId,
  selectedId = null,
}) => {
  return isMatter ? (
    <MatterEmailsCardsUI
      emails={emails}
      onSelectEmail={onSelectEmail}
      onOpenDetail={onOpenDetail}
      onToggleFavoriteEmail={onToggleFavoriteEmail}
      currentSearchInput={currentSearchInput}
      scrollCardRef={scrollCardRef}
      scrollCardId={scrollCardId}
      selectedId={selectedId}
    />
  ) : (
    <HREmailsCardsUI
      emails={emails}
      onSelectEmail={onSelectEmail}
      onOpenDetail={onOpenDetail}
      onToggleFavoriteEmail={onToggleFavoriteEmail}
      currentSearchInput={currentSearchInput}
      scrollCardRef={scrollCardRef}
      scrollCardId={scrollCardId}
      selectedId={selectedId}
    />
  );
};
